export const company = {
  name: "FA Interior Trim LLC",
  tagline: "Transforming homes, elevating spaces",
  shortDescription:
    "With over 20 years of experience, FA Interior Trim LLC transforms residential and commercial spaces with quality craftsmanship, personalized service, and detail-driven finishes.",
  about:
    "We specialize in transforming residential and commercial spaces into places that inspire. From custom trim details to full-scale remodeling, our team combines skilled craftsmanship with practical design solutions tailored to each client's vision.",
  address: "Hockley, TX 77447",
  phone: "(281) 352-2058",
  phoneHref: "+12813522058",
  email: "arce.trim@gmail.com",
  hours: "Mon to Sun: 7:00AM - 7:00PM",
  emergency: "Emergency Services: 24/7",
  social: {
    facebook: "https://www.facebook.com/fainteriortrimllc",
    instagram: "https://www.instagram.com/fainteriortrimllc",
  },
};

export const services = [
  {
    title: "Custom Cabinets",
    slug: "custom-cabinets",
    path: "/custom-cabinets",
    icon: "icon-interior-design-1",
    image: "gallery-01-built-in-media-wall.jpeg",
    summary:
      "Cabinet design and installation that blends style, storage, and a perfect fit for your space.",
    description:
      "Our custom cabinet service combines functionality with style to elevate kitchens, bathrooms, offices, living rooms, and specialty storage areas. We work closely with you to create cabinetry that fits your space, preferences, and daily use.",
    features: [
      "Personalized cabinetry designed for your room and style.",
      "Durable materials and finishes selected for long-lasting beauty.",
      "Precision-built storage for kitchens, bathrooms, offices, and living spaces.",
      "Detailed installation with clean lines and a polished final look.",
    ],
  },
  {
    title: "Complete Home Remodeling",
    slug: "complete-home-remodeling",
    path: "/complete-home-remodeling",
    icon: "icon-hotel",
    image: "gallery-10-white-built-ins.jpeg",
    summary:
      "Full renovation services that refresh and transform your home for better comfort and function.",
    description:
      "Our complete remodeling service helps reimagine your living space from concept to completion. Whether you want to modernize an outdated layout, improve functionality, or refresh multiple rooms, we plan and execute with clear communication and careful craftsmanship.",
    features: [
      "Full-scope renovations for kitchens, bathrooms, living areas, and more.",
      "Custom design solutions that reflect your lifestyle and priorities.",
      "Quality craftsmanship focused on comfort, beauty, and durability.",
      "A transparent process that keeps planning, budget, and timeline clear.",
    ],
  },
  {
    title: "Kitchen & Bathroom",
    slug: "general-kitchen-bathroom",
    path: "/general-kitchen-bathroom",
    icon: "icon-painting",
    image: "gallery-09-wood-hood.jpeg",
    summary:
      "Kitchen and bathroom upgrades that improve comfort, layout, finishes, and long-term value.",
    description:
      "We transform kitchens and bathrooms into practical, welcoming spaces with updated layouts, cabinetry, fixtures, trim, and finishes. Every project is tailored to your needs, budget, and preferred style.",
    features: [
      "Kitchen and bathroom remodeling for simple refreshes or full renovations.",
      "Cabinetry, fixtures, trim, and finish coordination.",
      "Layout improvements that make essential spaces easier to use.",
      "Careful installation for a clean, cohesive final result.",
    ],
  },
  {
    title: "Roofing Installation",
    slug: "roofing-installation",
    path: "/roofing-installation",
    icon: "icon-hammer",
    image: "service-roofing-installation.jpg",
    summary:
      "Roofing installation services that protect and enhance your property's exterior.",
    description:
      "Our roofing installation service focuses on durable materials, careful preparation, and reliable workmanship. We help protect your property while improving curb appeal and long-term performance.",
    features: [
      "Roof installation with durable materials and careful workmanship.",
      "Exterior protection planned around your property needs.",
      "Clean installation process with attention to details and safety.",
      "Roofing solutions that support comfort, value, and curb appeal.",
    ],
  },
  {
    title: "Drywall Installation & Repair",
    slug: "drywall-installation-repair",
    path: "/drywall-installation-repair",
    icon: "icon-wrench",
    image: "gallery-06-finished-shelving.jpeg",
    summary:
      "Drywall services for smooth walls and ceilings ready for paint, trim, and final finishes.",
    description:
      "From small repairs to full drywall installation, we prepare strong, smooth surfaces for any interior transformation. Our team focuses on aligned panels, seamless joints, and professional-grade finishing.",
    features: [
      "Drywall installation for remodels, additions, and interior updates.",
      "Precise repairs for cracks, holes, and damaged sections.",
      "Smooth finishes ready for paint, texture, cabinetry, and trim.",
      "Efficient, clean service for residential and commercial spaces.",
    ],
  },
  {
    title: "Doors, Windows & Painting",
    slug: "door-window-installation-painting",
    path: "/door-window-installation-painting",
    icon: "icon-crane",
    image: "gallery-08-barn-door.jpeg",
    summary:
      "Door, window, and painting services that refresh appearance, comfort, and function.",
    description:
      "We install and finish doors and windows with precision, then complete the look with smooth, durable painting. The result is a polished upgrade that fits your home or business design.",
    features: [
      "Door and window installation with a clean, secure fit.",
      "Interior painting and finish work for a cohesive look.",
      "Style options that match your home or business aesthetics.",
      "Durable results that improve appearance, comfort, and value.",
    ],
  },
];

export const galleryImages = [
  { src: "gallery-01-built-in-media-wall.jpeg", title: "Built-In Media Wall", category: "Custom Cabinets" },
  { src: "gallery-02-kitchen-cabinetry.jpeg", title: "Kitchen Cabinetry", category: "Custom Cabinets" },
  { src: "gallery-03-custom-shelving.jpeg", title: "Custom Shelving", category: "Trim & Built-Ins" },
  { src: "gallery-04-media-wall-progress.jpeg", title: "Media Wall Progress", category: "Custom Cabinets" },
  { src: "gallery-05-built-in-cabinetry.jpeg", title: "Built-In Cabinetry", category: "Custom Cabinets" },
  { src: "gallery-06-finished-shelving.jpeg", title: "Finished Shelving", category: "Trim & Built-Ins" },
  { src: "gallery-08-barn-door.jpeg", title: "Barn Door Installation", category: "Doors & Windows" },
  { src: "gallery-09-wood-hood.jpeg", title: "Wood Hood Detail", category: "Kitchen & Bathroom" },
  { src: "gallery-10-white-built-ins.jpeg", title: "White Built-Ins", category: "Custom Cabinets" },
  { src: "gallery-11-mudroom-door.jpeg", title: "Mudroom Door", category: "Doors & Windows" },
  { src: "gallery-12-mudroom-bench.jpeg", title: "Mudroom Bench", category: "Custom Cabinets" },
  { src: "gallery-13-custom-closet.jpeg", title: "Custom Closet", category: "Custom Cabinets" },
  { src: "gallery-14-closet-storage.jpeg", title: "Closet Storage", category: "Custom Cabinets" },
  { src: "gallery-15-stair-rail.jpeg", title: "Stair Rail Finish", category: "Interior Trim" },
  { src: "gallery-17-wall-pattern.jpeg", title: "Wall Pattern Detail", category: "Interior Trim" },
  { src: "service-roofing-installation.jpg", title: "Roofing Installation", category: "Roofing" },
];

export const assetPath = (fileName) => `${process.env.PUBLIC_URL}/assets/images/fa-interior-trim/${fileName}`;

export const getServiceBySlug = (slug) =>
  services.find((service) => service.slug === slug) || services[0];
